import { render, staticRenderFns } from "./ServiceHistory.vue?vue&type=template&id=a990201c&"
import script from "./ServiceHistory.vue?vue&type=script&lang=js&"
export * from "./ServiceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports